import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { getEventos, getEvento, updateEvento, getTiposAnomalia, deleteEvento, getEventoHistorial, getEventosConteoPorEstado } from '../api/eventos'

export const useEventos = (filters) => {
  return useQuery({
    queryKey: ['eventos', filters],
    queryFn: () => getEventos(filters),
    staleTime: 2 * 60 * 1000, // 2 minutos
  })
}

export const useEvento = (id) => {
  return useQuery({
    queryKey: ['evento', id],
    queryFn: () => getEvento(id),
    enabled: !!id,
  })
}

export const useUpdateEvento = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, data }) => updateEvento(id, data),
    onSuccess: (data, variables) => {
      // Invalidar queries relacionadas
      queryClient.invalidateQueries({ queryKey: ['eventos'] })
      queryClient.invalidateQueries({ queryKey: ['evento', variables.id] })
      queryClient.invalidateQueries({ queryKey: ['historial', variables.id] })
      queryClient.invalidateQueries({ queryKey: ['eventos-conteo'] }) // Invalidar conteos
      toast.success('Evento actualizado correctamente')
    },
    onError: () => {
      toast.error('Error al actualizar el evento')
    },
  })
}

export const useDeleteEvento = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id) => deleteEvento(id),
    onSuccess: () => {
      // Invalidar queries relacionadas
      queryClient.invalidateQueries({ queryKey: ['eventos'] })
      queryClient.invalidateQueries({ queryKey: ['eventos-conteo'] }) // Invalidar conteos
      toast.success('Evento eliminado correctamente')
    },
    onError: () => {
      toast.error('Error al eliminar el evento')
    },
  })
}

export const useTiposAnomalia = () => {
  return useQuery({
    queryKey: ['tipos-anomalia'],
    queryFn: getTiposAnomalia,
    staleTime: 30 * 60 * 1000, // 30 minutos (los tipos no cambian con frecuencia)
  })
}

export const useEventoHistorial = (id) => {
  return useQuery({
    queryKey: ['historial', id],
    queryFn: () => getEventoHistorial(id),
    enabled: !!id,
  })
}
